import React from 'react'
import { Link, NavLink } from 'react-router-dom'

const Nav = () =>
  <nav>
    <section className="container">
      <aside>
        <Link to="/" className="brand-title">{ROOT_DATA.generalInfo.name}</Link>
      </aside>
      <aside className="link-border">
        <NavLink to="/" exact>Work</NavLink>
        <NavLink to="/about">About</NavLink>
        <NavLink to="/sounds">Sounds</NavLink>
        <NavLink to="/contact" className="btn">Contact</NavLink>
      </aside>
    </section>
  </nav>

export default Nav



// WEBPACK FOOTER //
// src/javascripts/components/Nav.js